import AxiosService from '../../../gateway/rest/AxiosService'

class ConnectedAppRestService {
  create(connectedApp: any): Promise<any> {
    return AxiosService.post('/salesforce/connectedapps', connectedApp)
  }
}

export default new ConnectedAppRestService()
